import React, { useState, useEffect } from 'react';

const VisibleWeeks = ({ value = 10, onChange, onChangeStart, onChangeEnd, disabled = false, startDate }) => {
  const [weeks, setWeeks] = useState(value);
  const [isDragging, setIsDragging] = useState(false);

  // Globaler MouseUp-Event-Listener
  useEffect(() => {
    const handleGlobalMouseUp = () => {
      if (isDragging) {
        setIsDragging(false);
        if (onChangeEnd) {
          onChangeEnd(weeks);
        }
      }
    };

    if (isDragging) {
      document.addEventListener('mouseup', handleGlobalMouseUp);
      return () => {
        document.removeEventListener('mouseup', handleGlobalMouseUp);
      };
    }
  }, [isDragging, weeks, onChangeEnd]);

  const handleChange = (e) => {
    if (disabled) return;
    const newValue = parseInt(e.target.value);
    setWeeks(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleMouseDown = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    setIsDragging(true);
    if (onChangeStart) {
      onChangeStart();
    }
  };

  const handleMouseUp = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (isDragging) {
      setIsDragging(false);
      if (onChangeEnd) {
        onChangeEnd(weeks);
      }
    }
  };

  const handleWheel = (e) => {
    if (disabled) return;
    e.preventDefault();
    const delta = e.deltaY > 0 ? -1 : 1;
    const newValue = Math.max(4, Math.min(50, weeks + delta));
    
    if (newValue !== weeks) {
      setWeeks(newValue);
      if (onChange) {
        onChange(newValue);
      }
      // Bei Mausrad sofort onChangeEnd aufrufen (kein Dragging)
      if (onChangeEnd) {
        onChangeEnd(newValue);
      }
    }
  };

  return (
    <div style={{ marginTop: 16, padding: '0 5px', opacity: disabled ? 0.5 : 1 }}>
      <label style={{ 
        display: 'block', 
        marginBottom: '8px', 
        fontSize: '14px', 
        fontWeight: '500',
        color: disabled ? '#999' : '#333'
      }}>
        {startDate ? (
          <>Anzeige: {startDate.toLocaleDateString('de-DE')} - {new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + (weeks * 7) - 1).toLocaleDateString('de-DE')}</>
        ) : (
          <>Anzeige {disabled && '(Öffne InfoPanels schließen)'}</>
        )}
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <input
          type="range"
          min="4"
          max="50"
          value={weeks}
          onChange={handleChange}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onWheel={handleWheel}
          disabled={disabled}
          style={{
            flex: 1,
            height: '6px',
            borderRadius: '3px',
            background: disabled ? '#ccc' : '#ddd',
            outline: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
            pointerEvents: disabled ? 'none' : 'auto'
          }}
        />

      </div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        fontSize: '12px', 
        color: '#666',
        marginTop: '4px'
      }}>
        <span>4</span>
        <span>50</span>
      </div>
    </div>
  );
};

export default VisibleWeeks;
